<template>
  <div :class="[
    appState.appClass,
    'theme-' + appState.appTheme,
    ]">
    <div id="appbox"
      :class="{
        'showing-footer-box': appState.fantasy.showEdit,
        'app-hang': appState.hangDailog.show,
        'on-left': appState.hangDailog.show && appState.hangDailog.position
        }">
      <div v-if="showHeader" class="app-info" :class="[appState.appKind ? 'app-key' : '']">
        <div id="usermenu">{{appState.user.name}}</div>
        <div v-if="appState.appKind && appState.appKind.isWorkflow">App Key: {{appKey}}</div>
      </div>

      <div class="header" v-if="stageName">
        <p>{{stageName}}</p>
      </div>
      <div v-if="appState.appKind && appState.appKind.isWorkflow">
        <h1 class="title">Roanuz Sports Workflow</h1>
        <sub-menu v-if="appState.userLoggedIn"></sub-menu>
      </div>
      <template  v-else>
        <div v-if="showHeader" class="top-nav">
          <h1 class="title">Litzscore</h1>
          <main-menu v-if="appState.userLoggedIn"></main-menu>
        </div>
      </template>
      <breadcrumb></breadcrumb>
      <router-view class="page-content"/>
      <fantasy-create-team
        class="on-app-screen"
        v-if="appState.fantasy.showEdit"
        :team="appState.fantasy.team"
      ></fantasy-create-team>
    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/themes.scss"></style>
<style lang="scss">
</style>
<script>
import Config from '@/config'
import CookieManager from './helpers/cookiemanager'
import { AppState, AppKind } from './state'
export default {
  data () {
    return {
      stageName: Config.StageName,
      // themeName: Config.ThemeName || 'dark',
      appKey: CookieManager.getItem('rzForAppkey')
    }
  },
  beforeCreate () {
    document.body.className = 'app-theme-' + AppState.instance.appTheme
  },
  computed: {
    themeName () {
      console.log(Config.ThemeName || 'dark')
      return Config.ThemeName || 'dark'
    },
    showHeader () {
      if (this.$route.query && this.$route.query.popup === 'true') {
        const element = document.querySelector('.app-theme-' + AppState.instance.appTheme)
        element.style.backgroundColor = '#343746'
        return false
      } else {
        const element = document.querySelector('.app-theme-' + AppState.instance.appTheme)
        element.style.backgroundColor = '#fff'
        return true
      }
    }
  }
}
</script>
